// extracted by mini-css-extract-plugin
export default {"operatorPage":"Widget_operatorPage__FnoeT","operatorContent":"Widget_operatorContent__Ldgo4","operatorFrame":"Widget_operatorFrame__O-cG-"};